import React from 'react'
import Constants from '../../../../util/Constants'

const border = {
  'false|false' : '2px solid #333',
  'true|false' : '2px solid #ff0099',
  'false|true' : '2px solid #333',
  'true|true' : '2px solid #ff0099',
}

const background = {
  red : 'rgba(255,0,0,0.5)',
  green : 'rgba(0,255,0,0.3)',
  blue : 'rgba(0,0,255,0.3)',
  yellow : 'rgba(255,255,0,0.5)',
  cyan : 'rgba(0,255,255,0.3)',
  magenta : 'rgba(255,0,255,0.3)',
  white : 'rgba(255,255,255,0.3)',
}

export default function SpatialItem( props ) {
  const { item, selected, rollover } = props

  const imageRatios = {
    ...Constants.SHELF_MONITORING_IMAGE_SIZE.segment,
    original : item.data.data.data.detection.dimensions ?? Constants.SHELF_MONITORING_IMAGE_SIZE.segment.original
  }

  const bbox = item.data.data.data.detection.bbox
  const widthRatio = imageRatios.thumbnail.width / imageRatios.original.width
  const heightRatio = imageRatios.thumbnail.height / imageRatios.original.height
  const key = `${selected}|${rollover}`
  const height = bbox.height * heightRatio

  const style = {
    position : 'absolute',
    left : bbox.left * widthRatio,
    // bottom : bbox.top * heightRatio,
    top : imageRatios.thumbnail.height - ( bbox.top * heightRatio ) - height,
    width : bbox.width * widthRatio,
    height,
    background : background.red,
    border : rollover ? border[key] : '2px solid #ff0099',
    // boxShadow : rollover ? '0 0 5px 2px #ff0099' : 'none',
  }

  return (
    <div style={style} />
  )
}
